import { Injector } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TConfigurationFormModelTypes } from '../../../../models/form-builder-types-configurations.model';
import { getDefaultBaseSettingsConfigFormly } from '../../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import {
  dateTimePickerFieldParseIntoSettingsFormModel,
  dateTimePickerFieldUpdateFromSettingsFormModel,
  defaultDateTimePickerConfigFormModel,
  generateDateTimePickerForms,
} from '../custom-datetimepicker-field.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class CustomDateTimePickerFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);

    this.settingsFormlyModel = defaultDateTimePickerConfigFormModel;
    this.settingsFormlyForm = [
      ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
      ...generateDateTimePickerForms(),
    ];
    this.availableValidations.push(
      'invalidDate',
      'minDate',
      'maxDate',
      'unavailableSlots',
      'dayOfWeekIsNotAllowed',
      'dateAndTimeValuesRequired',
      'invalidTimeValue',
      'invalidDateTimeFormat'
    );
  }

  override parseFieldConfigIntoSettingsFormModel(): TConfigurationFormModelTypes {
    return dateTimePickerFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(model: any) {
    return dateTimePickerFieldUpdateFromSettingsFormModel(this.field, model);
  }
}
